import React, { useState, useEffect, useRef } from "react";
import img1 from "../assets/image_1.svg";
import search from "../assets/Vector.svg";
import drawer from "../assets/Vector1.svg";
import { useNavigate } from "react-router-dom";
import { Link, NavLink, useLocation } from "react-router-dom";

function Navbar({ isDrawerOpen, onDrawerClose, drawerRef }) {
  const [open, setOpen] = useState(false);
  const [posts, setPosts] = useState([]);
  let navigation = useNavigate();
  const location = useLocation();

  //set Language
  const lang = location.pathname.split("/")[1];

  function handleClick() {
    if (lang === "english" || "hindi") {
      let path = `/${lang}/fintragpt`;
      navigation(path);
    }
    let path = `/english/fintragpt`;
    navigation(path);
  }
  function renderSearchBar() {
    return (
      <img
        className="w-8 h-8 hover:cursor-pointer"
        src={search}
        alt=""
        onClick={handleClick}
      />
    );
  }

  const openDrawer = () => setOpen(true);

  const closeDrawer = () => {
    setOpen(false);
    onDrawerClose(); // Calls the onDrawerClose function from the App component
  };

  useEffect(() => {
    fetch(`${process.env.REACT_APP_API}${lang}?debug=true`)
      .then((response) => response.json())
      .then((data) => {
        setPosts(data["navigation"]);
      })
      .catch((err) => {
        console.log(err.message);
      });

    const handleClickOutsideDrawer = (event) => {
      if (drawerRef.current && !drawerRef.current.contains(event.target)) {
        closeDrawer();
      }
    };

    document.addEventListener("mousedown", handleClickOutsideDrawer);
    window.addEventListener("scroll", handleClickOutsideDrawer);

    return () => {
      window.removeEventListener("scroll", handleClickOutsideDrawer);
    };

    return () => {
      document.removeEventListener("mousedown", handleClickOutsideDrawer);
    };
  }, [lang]);

  const navigate = useNavigate();

  if (open) {
    return (
      <div ref={drawerRef} className="flex-col">
        <nav className=" flex items-center top-0 bg-white m-0 rounded-t-lg p-4 justify-between">
          <div className="flex flex-row  justify-between items-center gap-2">
            <img className="w-8 h-8 rounded-full" src={img1} alt="" />
            <div className="text-cyan-500 text-lg font-bold font-montserrat">
              Fintra
            </div>
          </div>

          <div className="flex flex-row  justify-between  gap-6">
            {renderSearchBar()}
            <img
              className="w-8 h-8 hover:cursor-pointer "
              src="https://cdn-icons-png.flaticon.com/512/5244/5244832.png"
              alt=""
              onClick={closeDrawer}
            />
          </div>
        </nav>
        <div className="w-full text-black flex justify-center font-montserrat flex-col mr-4 border-2 bg-white">
          {posts.map((post, index) => (
            <div
              className="flex p-2 justify-center hover:cursor-pointer hover:text-[#00C6CA]"
              key={index}
              onClick={() => {
                navigate(post.href, { replace: true });
                closeDrawer();
              }}
            >
              {post.caption}
            </div>
          ))}
        </div>
      </div>
    );
  } else
    return (
      <div>
        <nav className=" flex items-center top-0 bg-white rounded-t-lg p-4 shadow-lg justify-between md:justify-center md:gap-6">
          <div
            className="flex flex-row gap-2"
            onClick={() => {
              navigate("/english", { replace: true });
            }}
          >
            <img className="w-8 h-8 rounded-full" src={img1} alt="" />
            <div className="text-cyan-500 text-lg font-bold font-montserrat">
              Fintra
            </div>
          </div>

          <div
            className="hidden justify-between items-center w-full md:flex md:w-auto"
            id="mobile-menu-2 lg:hidden sm:hidden"
          >
            <ul className="flex flex-col mt-4 font-medium lg:flex-row lg:space-x-8 lg:mt-0">
              {posts &&
                posts.map((post, index) => {
                  return (
                    <li key={index}>
                      <NavLink
                        key={index}
                        exact
                        to={post.href}
                        className={({ isActive }) =>
                          `block py-2 pr-4 pl-3 duration-200 ${
                            location.pathname === post.href
                              ? "text-cyan-500"
                              : "text-gray-700"
                          } border-b border-gray-100 hover:bg-gray-50 lg:hover:bg-transparent lg:border-0 hover:text-cyan-500 lg:p-0`
                        }
                      >
                        {post.caption}
                      </NavLink>
                    </li>
                  );
                })}
            </ul>
          </div>

          <div className="flex flex-row justify-between gap-6 md:hidden">
            {renderSearchBar()}

            <img
              className="w-8 h-8 hover:cursor-pointer"
              src={drawer}
              alt=""
              onClick={openDrawer}
            />
          </div>
        </nav>
      </div>
    );
}

export default Navbar;
